module.exports = __webpack_public_path__ + "static/media/online_shop-min.f88874d4.png";